export default "/assets/images/mila-room-showcase-sm-03.jpg?5f81c3ca6e577bee3bd558004c40456e";